module.exports = __webpack_public_path__ + "media/stylesheets/images/layers-9289d694e7a832e81549a1137656070d.png";